import { render, staticRenderFns } from "./BulkQuoteProvidersList.vue?vue&type=template&id=5ccb8ef7"
import script from "./BulkQuoteProvidersList.vue?vue&type=script&lang=js"
export * from "./BulkQuoteProvidersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports